import type { Match } from "@/lib/types";
import { slotsForMatch, defaultSlotForMatch } from "./matchSlots";

export function matchHref(match: Match): string {
  const slot =
    slotsForMatch(match).find(
      (s) => match.video_status?.[s] === "ready" && match.videos?.[s],
    ) ?? defaultSlotForMatch(match);
  return `/match/${encodeURIComponent(match.slug)}?slot=${encodeURIComponent(slot)}`;
}
